import React, { useState, useEffect, useRef } from 'react';
import { I_Group } from '@Redux/detail/Group/interfaces';
import * as Icons from '@components/Common/Icons';
import Flag from '@components/Common/Flag';
import AlertText from '@components/Common/AlertText';
import axios from 'axios';
import domainByEnv from '@utils/domainByEnv';
import { getIsFavorite, handleFavorite } from '@utils/favorite';
import { getIsCompared, handleCompare } from '@utils/compare';
import { member } from '@utils/domainByEnv';
import FBimg from './imgs/fb.jpg';
import Lineimg from './imgs/line.jpg';
import styles from './styles.module.scss';

interface I_FavData {
    ProductList: I_FavItem[];
}

interface I_FavItem {
    TravelType: string; // 旅遊型態
    ProductID: string; // GroupID
    NormGroupID: string; // 標準團名
    Price: number; // 價格
    Days: number; // 天數
}

const GroupHead = () => {
    const { travelinfo } = document.getElementById('detailPagePara')!.dataset!;
    const { GroupInfo, ProductType }: I_Group = JSON.parse(travelinfo!);
    const {
        TourDays,
        GoDate,
        NormGroupID,
        TourName,
        GroupID,
        TravelType,
        IsVip,
        VipOrigPrice,
        Price,
        TagList,
    } = GroupInfo;
    const [isFavorite, setIsFavorite] = useState<boolean>(false);
    const [isCompared, setIsCompared] = useState<boolean>(false);
    const [isLogin, setIsLogin] = useState<boolean>(false);
    const [hasClicked, setHasClicked] = useState<boolean>(false);
    const typeOfButtonClickedRef = useRef<'compared' | 'favorite' | 'init'>('init'); // 哪個按鈕被點擊，'compared' | 'favorite' | 'init'

    useEffect(() => {
        (async function () {
            try {
                const memberRes = await fetch(`${member}/account/checkmemberlogin`, {
                    method: 'post',
                    // 會帶 cookie 過去
                    credentials: 'include',
                });
                const memberData = await memberRes.json();
                setIsLogin(memberData.IsLogin);
            } catch (ex) {
                console.log('Fetch Member Data Error', ex);
            }
        })();

        window.CancelFavorite = (deleteItem: any) => {
            if (deleteItem.groupId === GroupID) {
                setIsFavorite(false);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 一進頁面時，如果有 Login，則判斷有沒有加入收藏 & 比較
    useEffect(() => {
        if (isLogin) {
            (async () => {
                const favList = await getIsFavorite(TravelType);
                const isFaved = (groupID: string) =>
                    Boolean(favList?.find((favItem: any) => favItem.ProductID === groupID)) ||
                    false;

                const favedGroup = isFaved(GroupID);
                setIsFavorite(favedGroup);
            })();
        }
        (async () => {
            await getIsCompared({
                TourDays,
                GoDate: GoDate,
                NormGroupID,
                NormGroup: TourName,
                GroupID: GroupID,
                TravelType,
                setIsCompared,
            });
            // 若在未登入時，點擊收藏
            // 登入完後，會再觸發一次加入收藏
            if (isLogin) {
                if (sessionStorage.getItem('waitedForAddedFav') === GroupID) {
                    await handleFavorite({
                        isLogin,
                        isFavorite,
                        TravelType,
                        Price: IsVip ? VipOrigPrice : Price,
                        TourDays,
                        NormGroup: TourName,
                        NormGroupID,
                        GroupID: GroupID,
                        GoDate: GoDate,
                        setIsFavorite,
                    });
                    sessionStorage.removeItem('waitedForAddedFav');
                }
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLogin]);

    const socialShare = (media: 'fb' | 'line') => {
        // 將網址當參數時，需用 encodeURIComponent 編碼
        const productLink = encodeURIComponent(window.location.href);

        media === 'fb'
            ? window.open(
                  `https://www.facebook.com/sharer.php?u=${productLink}`,
                  'facebook-popup',
                  'height=640,width=640'
              )
            : window.open(
                  `https://social-plugins.line.me/lineit/share?url=${productLink}`,
                  'lineshare',
                  'width=640,height=640'
              );
    };

    const handleHasClicked = (type: 'compared' | 'favorite') => {
        setHasClicked(true);
        typeOfButtonClickedRef.current = type;
    };

    return (
        <div className={styles.group_notes}>
            <Flag ProductType={ProductType} TagList={TagList} />
            <div className={styles.group_notes_links}>
                <div
                    className={styles.group_notes_link}
                    onClick={async (e) => {
                        e.preventDefault();
                        await handleCompare({
                            TravelType,
                            Price: IsVip ? VipOrigPrice : Price,
                            TourDays,
                            NormGroup: TourName,
                            GoDate: GoDate,
                            GroupID: GroupID,
                            NormGroupID,
                            isCompared,
                            setIsCompared,
                        });
                        handleHasClicked('compared');
                    }}
                >
                    <Icons.Compare fill={isCompared ? '#f03742' : '#999'} width={15} height={15} />
                    <span style={isCompared ? { color: '#f03742' } : { color: '#222' }}>比較</span>
                </div>
                <div
                    className={styles.group_notes_link + ' ' + styles.marginRight20}
                    onClick={async (e) => {
                        e.preventDefault();
                        await handleFavorite({
                            isLogin: isLogin!,
                            isFavorite,
                            TravelType,
                            Price: IsVip ? VipOrigPrice : Price,
                            TourDays,
                            NormGroup: TourName,
                            NormGroupID,
                            GroupID: GroupID,
                            GoDate: GoDate,
                            setIsFavorite,
                        });
                        handleHasClicked('favorite');
                    }}
                >
                    {isFavorite ? (
                        <Icons.FillHeart fill="#f03742" width={13} height={13} />
                    ) : (
                        <Icons.HollowHeart fill="#999" width={13} height={13} />
                    )}
                    <span style={isFavorite ? { color: '#f03742' } : { color: '#222' }}>收藏</span>
                </div>
                <a href="#" className={styles.group_notes_share} onClick={() => socialShare('fb')}>
                    <img src={FBimg} alt="FB 連結" width={25} height={25} />
                </a>
                <a
                    href="#"
                    className={styles.group_notes_share}
                    onClick={() => socialShare('line')}
                >
                    <img src={Lineimg} alt="Line 連結" width={25} height={25} />
                </a>
            </div>
            {/* {點擊提醒視窗} */}
            {hasClicked && (
                <AlertText
                    isCompared={isCompared}
                    isFavorite={isFavorite}
                    typeOfAlert={typeOfButtonClickedRef.current}
                    setHasClicked={setHasClicked}
                />
            )}
        </div>
    );
};

export default GroupHead;
